import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=239a3a22&"
import script from "./ContactForm.vue?vue&type=script&lang=coffee&"
export * from "./ContactForm.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports